import { nowadaysApiUrl } from "@/utils/url-utils";

/**
 * POSTs to the support-chat close endpoint to end the user's active thread.
 *
 * Fire-and-forget: callers should not gate UI on the response. The
 * `support-chat:closed` WebSocket event is the source of truth for the
 * "Conversation closed" UI transition (this keeps admin-initiated and
 * user-initiated closes on a single code path and fans out to other tabs).
 *
 * The endpoint is idempotent — safe to call when no thread is open.
 *
 * @param accessToken - Supabase JWT for the Authorization header.
 */
export const closeSupportChat = async (accessToken: string): Promise<void> => {
  try {
    await fetch(nowadaysApiUrl("/support-chat/close"), {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  } catch {
    // Network or backend error — not surfaced because the user already
    // dismissed the widget. The next message POST starts a fresh thread
    // even if the close didn't land server-side.
  }
};
